"use client"

import { useQuery } from "@tanstack/react-query"

import { getShopifyTopupOptionsAction } from "@/server-actions/shopify/topups"

export const shopifyTopupOptionsQueryKey = ["shopify", "topup-options"] as const

export function useShopifyTopupOptionsQuery(enabled: boolean) {
  return useQuery({
    queryKey: shopifyTopupOptionsQueryKey,
    enabled,
    queryFn: async () => {
      const result = await getShopifyTopupOptionsAction({})
      if ("status" in result) throw new Error(result.errorMessage)
      return result
    },
  })
}
